module.exports = __webpack_public_path__ + "img/设计说明.22c6f098.png";